import { render, staticRenderFns } from "./lazy-image.vue?vue&type=template&id=05ed6915&scoped=true&"
import script from "./lazy-image.vue?vue&type=script&lang=js&"
export * from "./lazy-image.vue?vue&type=script&lang=js&"
import style0 from "./lazy-image.vue?vue&type=style&index=0&id=05ed6915&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ed6915",
  null
  
)

export default component.exports